import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { FontDriver } from 'src/app/types/sl-fonts';
import { DataURLToUint8Array } from 'src/app/model/formatters/data-fomatter';
import fontkit from '@pdf-lib/fontkit';
@Injectable({
  providedIn: 'root'
})
export class FontService {

  constructor(private wapi: SlWapiService) { }
  private driver: FontDriver;
  private symbolFonts: any;
  private symbolFontLU: any;
  ListFonts(): Promise<FontDriver> {
    return new Promise((resolve, reject) => {
      if (this.driver === undefined) {
        this.wapi.Post('media/fonts/driver', {}, true).then((result) => {
          this.driver = result.driver;
          resolve(result.driver);
        }).catch((reason: any) => {
          reject(reason);
        });
      } else {
        resolve(this.driver);
      }
    });
  }
  GetFont(family: string) {

  }
  ListSymbolFonts(): Promise<FontDriver> {
    return new Promise((resolve, reject) => {
      if (!this.symbolFonts) {
        this.wapi.Post('media/fonts/list', {}, true).then((response) => {
          this.symbolFonts = {};
          this.symbolFontLU = [];
          for (const symbol of response.results) {
            const symbolFont: any = ({ name: symbol, font: symbol.replaceAll(' ', '-').toLowerCase() });
            this.symbolFontLU.push(symbolFont);
            // const dataUrl: string = rootStyles.getPropertyValue('--' + symbolFont.font + '-src');
            if (!symbolFont?.font) return;
            const fontData = this.GetFontData(symbolFont.font).then((value) => {
              if (!value) return;
              this.symbolFonts[symbolFont.font] = fontkit.create(value);

            });
          }
          resolve(this.symbolFontLU);
        }).catch((reason: any) => {
          reject(reason);
        });
      } else {
        resolve(this.symbolFontLU);
      }
    });
  }
  async GetFontKitFont(fontFamily) {
    switch (fontFamily) {
      case 'font-awesome-solid':

    }
    if (!!this.symbolFonts && this.symbolFonts[fontFamily]) {
      return this.symbolFonts[fontFamily];
    }
    return await this.GetFontData(fontFamily).then((val) => {
      return fontkit.create(val);
    })

  }
  async GetFontData(fontFamily) {
    if (!!this.symbolFonts && this.symbolFonts[fontFamily]) {
      return this.symbolFonts[fontFamily];
    }
    const params = { family: fontFamily }
    let font = '';
    switch (fontFamily) {
      case 'font-awesome-solid':
        font = 'fa-solid-900.ttf'
        break;
      case 'font-awesome-regular':
        font = 'fa-regular-400.ttf';
        break;
      case 'map-symbols':
        font = 'mapsymbols.ttf';
        break;
      case 'road-signs':
        font = 'ROADSIGN.TTF';
        break;
      case 'road-signs-w':
        font = 'RD_SGN_W.TTF';
        break;
      case 'dejavu-sans-mono':
        font = 'DejaVuSansMono.ttf';
        break;
    }
    const response = await fetch('/assets/fonts/' + font);
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    return uint8Array;
  }
}
